import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";
import { breakpoints } from "plos/src/styles/breakpoints";

export const benchUnitHeading = style({
  padding: `${vars.space.xs} 0`,
  textAlign: "center",
  lineHeight: 1.4,
  color: vars.colors.primaryFixed,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.s,
});

export const benchHeader = style({
  textAlign: "center",
  color: vars.colors.onSurface,
  fontSize: vars.fontSizes.heading.xl,
});

export const benchContentWrap = style({
  display: "flex",
  flexDirection: "column-reverse",
  gap: vars.space.m,
  backdropFilter: vars.blur[10],
  borderRadius: vars.radii.s,
  background: `linear-gradient(to top, 
    color-mix(in srgb, ${vars.colors.white} 0%, transparent) 0%,
    color-mix(in srgb, ${vars.colors.white} 35%, transparent) 87.91%)`,
});

const benchInnerBase = style({
  display: "flex",
  gap: vars.space.m,
  padding: `0 ${vars.space.m}`,
  width: "100%",
  "@media": {
    [`screen and (min-width: ${breakpoints[3]})`]: {
      gap: vars.space.l,
      padding: `0 ${vars.space.xl}`,
    },
  },
});

export const benchStyles = style({
  display: "flex",
  justifyContent: "center",
  "@media": {
    [`screen and (min-width: ${breakpoints[3]})`]: {
      paddingTop: vars.space.s,
    },
  },
});

export const benchInner = styleVariants({
  default: [benchInnerBase],
  bboost: [
    benchInnerBase,
    {
      border: `2px solid ${vars.colors.onSuccess}`,
      borderRadius: `${vars.radii.m} ${vars.radii.m} 0 0`,
      boxShadow: `0 0 0 2px ${vars.colors.white}, 0 0 0 6px ${vars.colors.plBlue}`,
    },
  ],
});
